import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import { addMessageToFavouriteApi, removeMessageFromFavouriteApi } from "../../API/API";

function* addMessageFavouritSaga(action) {
  try {
    const response = yield call(() => addMessageToFavouriteApi(action));
    yield put({ type: types.ADD_MESSAGE_TO_FAVOURITE_SUCCESS, payload: response.data });
    yield put({ type: types.FAVOURITE_SUCCESS, payload: action?.payload?.Index});
  } catch (error) {
    yield put({ type: types.ADD_MESSAGE_TO_FAVOURITE_FAILURE, error });
  }
}

function* removeMessageFavouriteSaga(action) {
  try {
    const response = yield call(() => removeMessageFromFavouriteApi(action));
    yield put({ type: types.REMOVE_MESSAGE_TO_FAVOURITE_SUCCESS, payload: response.data });
    yield put({ type: types.REMOVE_FAV_SUCCESS, payload: action?.payload?.Index});
  } catch (error) {
    yield put({ type: types.REMOVE_MESSAGE_TO_FAVOURITE_FAILURE, error });
  }
}


  export function* watchAddMessageFavouriteSaga() {
    yield takeLatest(types.ADD_MESSAGE_TO_FAVOURITE_REQUESTED, addMessageFavouritSaga);
  }

  export function* watchRemoveMessageFavouriteSaga() {
    yield takeLatest(types.REMOVE_MESSAGE_TO_FAVOURITE_REQUESTED, removeMessageFavouriteSaga);
  }